import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});


const getLatestResultOfHorsesWithTrainerSlice = createSlice({
    name: 'LatestResultOfHorsesWithTrainer',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchLatestResultOfHorsesWithTrainer.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchLatestResultOfHorsesWithTrainer.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchLatestResultOfHorsesWithTrainer.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setTrainer, setStatus } = getLatestResultOfHorsesWithTrainerSlice.actions;
export default getLatestResultOfHorsesWithTrainerSlice.reducer;

export const fetchLatestResultOfHorsesWithTrainer = createAsyncThunk('/FutureEntries/fetch', async ({ id }) => {
    const res = await axios.get(`${getBaseUrl()}/LatestResultOfHorsesWithTrainer/${id}`);
    const trainerstatsData = res.data;
    return trainerstatsData.data;
})